<template>
    <!-- 运输统计 -->
    <div>
        <!-- 头部-->
        <div class="child-head">
            <!-- 标题 -->
            <div class="child-head-left float-l">
                <img src="../../assets/area_title.png" class="head-img">
                <span>运输统计</span>
            </div>
            <!-- tab选项 -->
            <div class="child-head-right float-r">
                <div @click="selTab(0)" :class="tabIndex == 0 ? 'border-tab' : ''">规模</div>
                <div @click="selTab(1)" :class="tabIndex == 1 ? 'border-tab' : ''">交易</div>
                <div @click="selTab(2)" :class="tabIndex == 2 ? 'border-tab' : ''">城市</div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="content content-chunk-box">
            <!-- 边角 -->
            <contentCorner>
                <!-- 内容 -->
                <div class="content-div">
                    <!-- 规模 -->
                    <div v-show="tabIndex == 0">
                        <div class="content-div-1 content-div-bgd">
                            <span><svg-icon icon-file-name="u476" style=" font-size: 30px;" /></span>
                            <span class="content-text-color">车辆</span>
                            <span class="font-text-d">{{ totalBranchQty }}</span>
                        </div>
                        <div class="content-div-1">
                            <div class="content-div-bgd content-div-2">
                                <span><svg-icon icon-file-name="u484" style=" font-size: 30px;" /></span>
                                <span class="content-text-color">企业</span>
                                <span class="font-text-d">{{ totalCompanyQty }}</span>
                            </div>
                            <div class="content-div-2 content-div-bgd content-div-3">
                                <span><svg-icon icon-file-name="u483" style=" font-size: 30px;" /></span>
                                <span class="content-text-color">司机</span>
                                <span class="font-text-d">{{ totalDriverQty }}</span>
                            </div>
                        </div>
                        <div class="content-div-1">
                            <div class="content-div-bgd content-div-2">
                                <span><svg-icon icon-file-name="u477" style=" font-size: 30px;" /></span>
                                <span class="content-text-color">项目</span>
                                <span class="font-text-d">{{ totalSubitemQty }}</span>
                            </div>
                            <div class="content-div-2 content-div-bgd  content-div-3">
                                <span><svg-icon icon-file-name="u480" style=" font-size: 30px;" /></span>
                                <span class="content-text-color">卸点</span>
                                <span class="font-text-d">{{ dumpPointQty }}</span>
                            </div>
                        </div>
                        <div class="content-div-1 content-div-bgd">
                            <span><svg-icon icon-file-name="u479" style=" font-size: 30px;" /></span>
                            <span class="content-text-color">订单 </span>
                            <span class="font-text-d"> {{ requireCount }} 笔 / {{ totalAmount }}</span>
                        </div>
                    </div>
                    <!--  交易-->
                    <div v-show="tabIndex == 1">
                        <dealEchart />
                    </div>
                    <!-- 城市 -->
                    <div v-if="tabIndex == 2" class="city-box">
                        <dv-scroll-board class="dv-scr-board" :config="config" />
                    </div>
                </div>
            </contentCorner>
        </div>
    </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
import { totalBranch, totalCompany, totalDriver, totalSubitem, transportTotalByCity, totalChecklist, getRequireCountAndTotalAmount } from '../../api/holdMy.js';
import { getToken } from '../../utils/getToken';
import dealEchart from '../../components/dealEchart'
export default {

    data() {
        return {
            refreshScaleing: null,   // 规模刷新定时器
            refreshTabing: null,
            refreshBranching: null,
            tabIndex: 0,    // tab下标
            totalBranchQty: 0,//车辆
            totalCompanyQty: 0,// 平台企业(家)
            totalDriverQty: 0,//活跃司机(人)
            totalSubitemQty: 0,//平台工地(个)(项目)
            dumpPointQty: 0,
            totalAmount: 0.00,        //总金额
            requireCount: 0,           // 总订单数
            config: {
                header: ['城市', '装点数', '车辆数', '运输'],
                data: [],
                rowNum: 5, //表格行数
                headerHeight: 35,
                headerBGC: 'rgba(26, 201, 255, 0.2980392156862745)', //表头
                oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
                evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
                align: ['left', 'right', 'right', 'right']
            }

        }
    },
    components: { contentCorner, dealEchart },
    created() {
        this.getTotalBranch();
        this.getTotalCompany();
        this.getCtalDriver();
        this.getTotalSubitem();
        this.getTotalChecklist();
        this.refreshScale();    // 定时刷新规模数据
        this.refreshTab();
        this.RequireCountAndTotalAmount();
        this.refreshBranch();
    },
    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.refreshScaleing);
        clearInterval(this.refreshTabing);
        clearInterval(this.refreshBranching);
    },
    methods: {
        // 切换tab
        selTab(index) {
            this.tabIndex = index;
            if (index == 2) {
                this.getTransportTotalByCity();
            }
        },
        // 自动切换tab
        refreshTab() {
            if (this.refreshTabing) {
                clearInterval(this.refreshTabing);
            }
            this.refreshTabing = setInterval(() => {
                var index = this.tabIndex + 1;
                if (index > 2) {
                    index = 0
                }
                this.tabIndex = index;
                this.selTab(this.tabIndex)
            }, 1000 * 60 * 30)
        },
        // ~~~~~~~~~规模~~~~~~~~~~~~~~
        // 获取平台车辆
        getTotalBranch() {
            let data = {
                autoIncId: 1,// id
            }
            totalBranch(data).then(res => {
                if (res.result == 0) {
                    this.totalBranchQty = res.userdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },

        // 获取平台企业(家)
        getTotalCompany() {
            let data = {
                autoIncId: 1,// id
                token: getToken("holdpjToken")
            }
            totalCompany(data).then(res => {
                if (res.result == 0) {
                    this.totalCompanyQty = res.userdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },

        // 活跃司机(人)
        getCtalDriver() {
            let data = {
                autoIncId: 1,// id
                token: getToken("holdpjToken")
            }
            totalDriver(data).then(res => {
                if (res.result == 0) {
                    this.totalDriverQty = res.userdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },

        //平台工地(个)(项目)
        getTotalSubitem() {
            let data = {
                autoIncId: 1,// id
                token: getToken("holdpjToken")
            }
            totalSubitem(data).then(res => {
                if (res.result == 0) {
                    this.totalSubitemQty = res.userdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },

        //卸点
        getTotalChecklist() {
            let data = {
                autoIncId: 1,// id
            }
            totalChecklist(data).then(res => {
                if (res.result == 0) {
                    this.dumpPointQty = res.userdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 获取总订单数&总金额
        RequireCountAndTotalAmount() {
            let data = {
                autoIncId: 1,// id
            }
            getRequireCountAndTotalAmount(data).then(res => {
                if (res.result == 0) {
                    this.requireCount = res.userdata.requireCount; //总订单数
                    this.totalAmount = res.userdata.totalAmount; //总金额
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 刷新规模数据半个小时
        refreshScale() {
            if (this.refreshScaleing) {
                clearInterval(this.refreshScaleing);
            }
            this.refreshScaleing = setInterval(() => {
                this.getTotalCompany();  // 获取平台企业(家)
                this.getCtalDriver(); // 活跃司机(人)
                this.getTotalSubitem();  //平台工地(个)(项目)
                this.getTotalChecklist(); //卸点
                this.RequireCountAndTotalAmount()
            }, 1000 * 60 * 30)
        },
        // 刷新规模数据半个小时
        refreshBranch() {
            if (this.refreshBranching) {
                clearInterval(this.refreshBranching);
            }
            this.refreshBranching = setInterval(() => {
                this.getTotalBranch();  // 获取平台车辆
            }, 1000 * 60 * 10)
        },

        //~~~~~~~~~~~~~城市~~~~~~~~~~~~~~~~~~~~~~

        // 获取城市运行列表数据
        getTransportTotalByCity() {
            let data = {
                autoIncId: 1
            }
            const that = this;
            transportTotalByCity(data).then(res => {
                if (res.result == 0) {
                    let transportTotalByCityQty = res.userdata;
                    var data1 = [];
                    transportTotalByCityQty.forEach(element => {
                        data1.push([element.city, element.subitemCount, element.branchCount, element.usageCount])
                    });
                    that.config.data = data1;
                    that.config = { ...that.config };//关键,展开数组对象重新赋值.不写数据出不来
                }
            }).catch(error => {
                console.log(error);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 233px;

    .content-div {
        padding: 10px 20px;

        .content-div-1 {
            margin: 8.5px 0;
            font-size: 20px;
            display: flex;
            line-height: 40px;

            span {
                margin: 1px 10px;
                // text-align: center;
            }
        }

        .content-div-bgd {
            background-color: rgba(26, 201, 255, 0.2980392156862745);
        }

        .content-text-color {
            color: #31A7FF;
        }
    }
}

.content-div-2 {
    width: 50%;
}

.content-div-3 {
    margin-left: 10px;
}

.font-text-d {
    font-size: 28px;
    font-family: 'Impact Normal', 'Impact', sans-serif;
    font-weight: 400;
}

.city-box {
    overflow: hidden;
    height: 210px;
    width: 460px;

    .dv-scr-board {
        width: 460px;
        height: 200px;
        font-size: 25px;
    }

}

::v-deep .city-box .dv-scr-board .header {
    color: #b2b2b2 !important;

}
</style>

